import loadable from '@wix/yoshi-flow-editor/loadable';
import {RichContentViewerProps, RichContentViewer} from './RichContentViewer';

export const LazyRichContentViewer: typeof RichContentViewer = loadable<RichContentViewerProps>(
  () => import(/* webpackChunkName: "LazyRichContentViewer" */ './RichContentViewer'),
  {
    resolveComponent: (components) => components.RichContentViewer,
  }
);
